import { Directive, ElementRef, HostListener, input, output } from "@angular/core";
import { SelectTableRow } from "../models";

@Directive({
  selector: "[commonSelectWholeRow]",
  standalone: true,
})
export class SelectWholeRowDirective<T> {
  constructor(private el: ElementRef) {}
  readonly rowData = input.required<SelectTableRow<T>>();
  readonly rowSelectionChange = output<SelectTableRow<T>>();

  @HostListener("click", ["$event"])
  onRowClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const isCheckboxClick = target.tagName === "INPUT" && target.getAttribute("type") === "checkbox";
    const isInteractiveElement = target.tagName === "BUTTON" || target.tagName === "A" || target.closest("button, a");

    if (isCheckboxClick || isInteractiveElement) {
      return;
    }
    const row = this.rowData();

    if (row) {
      row.selected = !row.selected;
      this.#updateRowClass(row.selected);
      this.rowSelectionChange.emit(row);
    }
  }

  #updateRowClass(isSelected: boolean): void {
    const rowElement = this.el.nativeElement.closest("tr");
    if (rowElement) {
      if (isSelected) {
        rowElement.classList.add("selected");
      } else {
        rowElement.classList.remove("selected");
      }
    }
  }
}
